import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { instituteMock } from '../data/mock';

const ContactForm = () => {
  const { contactFormSubjects } = instituteMock;
  const [formData, setFormData] = useState({
    name: '',
    whatsapp: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubjectChange = (value) => {
    setFormData(prev => ({ ...prev, subject: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.name || !formData.whatsapp || !formData.email || !formData.subject || !formData.message) {
      toast.error('Por favor, preencha todos os campos');
      return;
    }

    // Mock submission - will be replaced with real API call
    console.log('Form submitted:', formData);
    toast.success('Mensagem enviada com sucesso! Entraremos em contato em breve.');
    
    // Reset form
    setFormData({
      name: '',
      whatsapp: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact-form-wrapper">
      <h3 className="heading-2" style={{ marginBottom: '24px' }}>
        Envie sua mensagem
      </h3>
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-field">
          <Label htmlFor="name">Nome completo</Label>
          <Input
            id="name"
            name="name"
            type="text"
            value={formData.name}
            onChange={handleChange}
            placeholder="Seu nome completo"
            required
          />
        </div>

        <div className="form-field">
          <Label htmlFor="whatsapp">WhatsApp</Label>
          <Input
            id="whatsapp"
            name="whatsapp"
            type="tel"
            value={formData.whatsapp}
            onChange={handleChange}
            placeholder="(83) 98888-8888"
            required
          />
        </div>

        <div className="form-field">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="seu@email.com"
            required
          />
        </div>

        <div className="form-field">
          <Label htmlFor="subject">Assunto</Label>
          <Select value={formData.subject} onValueChange={handleSubjectChange} required>
            <SelectTrigger>
              <SelectValue placeholder="Selecione o assunto" />
            </SelectTrigger>
            <SelectContent>
              {contactFormSubjects.map((subject, index) => (
                <SelectItem key={index} value={subject}>
                  {subject}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="form-field">
          <Label htmlFor="message">Mensagem</Label>
          <Textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Descreva sua dúvida ou solicitação..."
            rows={5}
            required
          />
        </div>

        <Button type="submit" className="btn-primary" style={{ width: '100%' }}>
          Enviar mensagem
        </Button>
      </form>
    </div>
  );
};

export default ContactForm;
